// extracted by mini-css-extract-plugin
module.exports = {"product-name":"Autosuggest_product-name__3mAo5","product-category":"Autosuggest_product-category__1SWSK"};